import { useLazyQuery } from '@apollo/client';
import { IQueryResult, IVariables } from './interfaces';
import { paymentsGql } from './gql';

export const usePaymentsGql = () => {
  const [runPaymentsGql, { loading, data, error }] = useLazyQuery<IQueryResult, IVariables>(paymentsGql, {
    context: {
      headers: {
        userFunctionKey: '1ff1de774005f8da13f42943881c655f'
      }
    }
  });

  return {
    runPaymentsGql,
    loadingPayments: loading,
    dataPayments: data?.payments || [],
    errorPayments: error
  };
};
